/**
 *
 * @desc 个人中心/项目空间  计算价格、日期、周期逻辑
 **/

import dayjs from 'dayjs';

export default function useCalcAmount() {
    const UNIT_PRICE = 88;
    const [paymentAmount, setPaymentAmount] = useState(UNIT_PRICE); // 金额
    const [period, setPeriod] = useState(1);
    const [expireDate, setExpireDate] = useState(
        dayjs().add(1, 'month').format('YYYY-MM-DD')
    ); // 服务周期

    // 项目周期变化回调
    const periodChange = val => {
        const sum = val * UNIT_PRICE;
        setPeriod(val);
        setPaymentAmount(sum);
        setExpireDate(dayjs().add(val, 'month').format('YYYY-MM-DD'));
    };

    return [periodChange, paymentAmount, expireDate, period];
}
